/**
 * ISO 3166-1 alpha-2 country code → Unicode flag emoji.
 *
 * Built from the Regional Indicator Symbol range (U+1F1E6..U+1F1FF): the two
 * letters of the ISO code map to the two regional-indicator characters that
 * font renderers compose into a flag glyph. No icon asset, no lookup table —
 * the OS shapes the glyph from the code. Returns the empty string on missing
 * or malformed input, so the caller renders nothing (the marketing-team rule:
 * unknown country = blank cell, never an em-dash placeholder).
 */
const A_CHAR_CODE = 'A'.charCodeAt(0)
const REGIONAL_INDICATOR_A = 0x1f1e6

export const countryFlagEmoji = (countryCode: string | null | undefined): string => {
  if (countryCode == null) {
    return ''
  }

  const upper = countryCode.trim().toUpperCase()
  if (!/^[A-Z]{2}$/.test(upper)) {
    return ''
  }

  return String.fromCodePoint(
    REGIONAL_INDICATOR_A + (upper.charCodeAt(0) - A_CHAR_CODE),
    REGIONAL_INDICATOR_A + (upper.charCodeAt(1) - A_CHAR_CODE),
  )
}
